import { render, staticRenderFns } from "./donors-sort-by-select.vue?vue&type=template&id=6fea513b&"
import script from "./donors-sort-by-select.vue?vue&type=script&lang=js&"
export * from "./donors-sort-by-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports